// These define min and max for custom backdrop and annotations.
// TODO: this should come from mapconfig in future.
export const MIN_SCALE = 0;
export const MAX_SCALE = 5000;
export const TILED_WMS_LAYER = 'nuar:custombackdropmap';
export const TILED_WMS_LAYER_NAME = 'tiledwms';
// Some key layer names that we don't want to hardcode
export const ANNOTATIONS_ASSET_TYPE = 'networkannotations';
export const DIMENSIONS_ASSET_TYPE = 'networkdimensions';
export const NI_ANNOTATIONS_ASSET_TYPE = ANNOTATIONS_ASSET_TYPE + '-ni';
export const NI_DIMENSIONS_ASSET_TYPE = DIMENSIONS_ASSET_TYPE + '-ni';
// used to match against feature.getProperties().descriptiontype
export const DIMENSION_DESCRIPTION_TYPE = 'DIMENSION';

export const PREFIX_NETWORK = 'nuar:';
export const ANNOTATIONS_LAYER_NAME = PREFIX_NETWORK + ANNOTATIONS_ASSET_TYPE;
export const DIMENSIONS_LAYER_NAME = PREFIX_NETWORK + DIMENSIONS_ASSET_TYPE;
export const NI_ANNOTATIONS_LAYER_NAME = PREFIX_NETWORK + NI_ANNOTATIONS_ASSET_TYPE;
export const NI_DIMENSIONS_LAYER_NAME = PREFIX_NETWORK + NI_DIMENSIONS_ASSET_TYPE;

export const LAYER_CONFIG = {
    baseMap: {
        id: 'Base Map',
        zIndex: 0,
        description: 'Base map tiles rendered at the bottom of the stack'
    },
    backdropMap: {
        zIndex: 10,
        description: 'Custom backdrop mapping layer'
    },
    annotations: {

        zIndex: 20,
        description: 'User annotations overlay'
    },
    aoiBackdropBase: {
        id: 'aoi-backdrop-base',
        zIndex: 40,
        description: 'Base AOI backdrop'
    },
    aoiBackdropHiddenAssets: {
        id: 'aoi-backdrop-hidden-assets',
        zIndex: 41,
        description: 'AOI backdrop style for hidden/redacted assets'
    },
    aoiBackdropHiddenAssetsSelected: {
        id: 'aoi-backdrop-hidden-assets-selected',
        zIndex: 42,
        description: 'AOI backdrop style for selected hidden/redacted asset'
    },
    serviceAreaOverlay: {
        id: 'serviceAreaOverlay',
        zIndex: 45,
        description: 'Service area mask shown while drawing/modifying to indicate allowed area'
    },
    draw: {
        id: 'draw',
        zIndex: 50,
        description: 'Draw and modify interaction layer'
    },
    locationMarker: {
        id: 'locationMarker',
        zIndex: 51,
        description: 'Current user geolocation marker'
    },
    aoi: {
        id: 'aoi',
        zIndex: 52,
        description: 'AOI outline/border layer'
    },
    oneTapPreviewAOI: {
        id: 'oneTapPreviewAOI',
        zIndex: 2147483646, // Infinity - 1
        description: 'Mobile one-tap AOI crosshair and preview square'
    },
    dimensions: {
        // vector layer for dimensions uses defined id above
        zIndex: 2147483647, // Infinity
        description: 'Dimension labels and vectors rendered above all map layers'
    },
    assetLayers: {
        description: 'AssetLayers component manages multiple internal layers and their zIndex values'
    }
};

export default {
    MIN_SCALE,
    MAX_SCALE,
    TILED_WMS_LAYER,
    TILED_WMS_LAYER_NAME,
    ANNOTATIONS_ASSET_TYPE,
    DIMENSIONS_ASSET_TYPE,
    NI_ANNOTATIONS_ASSET_TYPE,
    NI_DIMENSIONS_ASSET_TYPE,
    DIMENSION_DESCRIPTION_TYPE,
    PREFIX_NETWORK,
    ANNOTATIONS_LAYER_NAME,
    DIMENSIONS_LAYER_NAME,
    NI_ANNOTATIONS_LAYER_NAME,
    NI_DIMENSIONS_LAYER_NAME,
    LAYER_CONFIG
};
